import { createFileRoute, redirect } from '@tanstack/react-router';

// Bare `/super-admin` has no page of its own — land on Users (the first item).
export const Route = createFileRoute('/_auth/_side-layout/super-admin/')({
  beforeLoad: () => {
    throw redirect({ to: '/super-admin/users', search: { offset: 0, q: '' } });
  },
});
